import { useMutation } from "react-query";
import { useIvideon } from "./useIvideon";
import { IvideonTariffsIProps } from "../model/schema";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: IvideonTariffsIProps;
  options?: MutateOptions;
}

export const useUpdateTariff = () => {
  const { updateTariff } = useIvideon();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await updateTariff(props.data);
      if (result.data) {
        return result.data;
      } else {
        throw new Error("Не удалось обновить договор");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });

  const update = (data: IvideonTariffsIProps, options?: MutateOptions) => {
    mutation.mutate({ data, options });
  };
  return { update };
};
